import React, { useEffect, useRef } from "react";
import ApexCharts from "apexcharts";

const RadialChart = ({amount,colorBar,colorText,radialValue}) => {
  const chartRef = useRef(null);

  useEffect(() => {
    const options = {
      series: [radialValue],
      chart: {
        height: 300,
        type: "radialBar",
      },
      plotOptions: {
        radialBar: {
          startAngle: 0,
          hollow: {
            size: "55%",
          },
          dataLabels: {
            name: {
              show: true, // Keep the label visible
              fontSize: "30px",
              color: `${colorText}`, // Set label color to red
              offsetY: 10, // Adds padding (moves text down)
            },
            value: {
              show: false, // Hide the series value
            },
          },
        },
      },
      labels: [`${amount}`],
      fill: {
        type: "solid",
        colors: [`${colorBar}`], // Set radial bar color to red
      },
      stroke: {
        // lineCap: "round", // Smooth curve
      },
    };

    const chart = new ApexCharts(chartRef.current, options);
    chart.render();

    return () => {
      chart.destroy(); // Cleanup on component unmount
    };
  }, []);

  return <div id="chart" ref={chartRef}></div>;
};

export default RadialChart;
